import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, first, tap } from 'rxjs/operators'
import { Storage } from '@ionic/storage'
import { environment } from 'src/environments/environment'
import { Platform } from '@ionic/angular'
import { DeviceDetectorService } from 'ngx-device-detector'
import { LogAppService } from '@services/features/log-app/log-app.service'
import { TranslatesService } from '@services/api/translate.service'

@Injectable()
export class TrackingInterceptor implements HttpInterceptor {
  constructor(
    private LogAppService: LogAppService,
    private storage: Storage,
    private platform: Platform,
    private deviceService: DeviceDetectorService,
    private translatesService: TranslatesService
  ) {}

  status1: boolean = true
  status2: boolean = true
  status3: boolean = true

  translate = this.translatesService.words

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((data) => {
        if (data.type == 0) {
        } else {
          this.validateLocal(request, data)
        }
      }),
      catchError((err) => {
        if (err.type == 0) {
        } else {
          this.validateLocal(request, err)
        }
        return throwError(err)
      })
    )
  }

  validateLocal(request, response) {
    if (this.status1) {
      this.storage?.get(environment.localStorage).then((user) => {
        try {
          this.insertInfo(user, request, response.status)
        } catch (error) {
          this.insertInfoBad(null, request, response.status)
        }
      })
    }
    this.status1 = !this.status1
  }

  insertInfo(valueLocalStorage, request, response) {
    let description = response
    this.getInfo(valueLocalStorage, description, request)
    this.status2 = true
  }

  insertInfoBad(valueLocalStorage, request, response) {
    if (this.status3) {
      let description = response
      this.getInfo(valueLocalStorage, description, request)
    }
    this.status3 = !this.status3
  }

  getInfo(valueLocalStorage, description: number, request) {
    let deviceInfo = this.deviceService.getDeviceInfo()

    let dataRequest =
      request.body != null
        ? 'password' in request.body
          ? { ...request.body, password: '*******', new_password: '*******' }
          : request.body
        : 'Vacio'

    let partsModule = window.location.href.split('/')
    let moduleNew = partsModule.pop()

    let partsEndpoint = request.url.split('/')
    let endpointNew = partsEndpoint.pop()

    let textRequest = JSON.stringify(dataRequest)

    let data = {
      users_id: valueLocalStorage != null ? valueLocalStorage.id : -1,
      user_name:
        valueLocalStorage != null ? valueLocalStorage.first_name + ' ' + valueLocalStorage.last_name : 'Desconocido',
      rol_id: valueLocalStorage != null ? valueLocalStorage.rol_id : -1,
      endpoint: request.url,
      method: request.method,
      url_origin: window.location.href,
      compilation: this.getCompilation(),
      browser: deviceInfo.browser,
      browser_version: deviceInfo.browser_version,
      device: deviceInfo.device,
      device_type: deviceInfo.deviceType,
      orientation: deviceInfo.orientation,
      os: deviceInfo.os,
      os_version: deviceInfo.os_version,
      app_version: environment.version,
      description: description + '',
      token: valueLocalStorage != null ? valueLocalStorage.token : 'Vacio',
      request: textRequest,
      module_origin: this.getPropertyValue(moduleNew),
      endpointNew: endpointNew,
      action: this.getActionFromMethod(request.method, request.url) + ' ' + this.getPropertyValue(endpointNew)
    }

    this.validateRequest(request.url, data)
  }

  validateRequest(url, data) {
    const containsAssets = url.includes('assets')
    const containsLog = url.includes('_log') || url.includes('log_a')

    if (!containsAssets && !containsLog) {
      this.sendTracking(data)
    }
  }

  getPropertyValue(propertyName: string): string {
    if (propertyName in this.translate) {
      return this.translate[propertyName][0]
    } else {
      return propertyName
    }
  }

  getActionFromMethod(method, url) {
    switch (method) {
      case 'GET':
        return 'Listar'
      case 'POST':
        if (url.includes('by_')) {
          return 'Listar'
        } else if (url.includes('login')) {
          return 'Inicio de sesión en'
        }
        return 'Creación de'
      case 'PUT':
        return 'Actualización de'
      default:
        return 'Desconocido'
    }
  }

  getCompilation() {
    let platform: string

    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      platform = 'app'
    } else {
      platform = 'browser'
    }

    return platform
  }

  sendTracking(data) {
    if (this.status2) {
      this.LogAppService.create(data)
        .pipe(first())
        .subscribe(
          (res) => {
            this.status2 = true
          },
          (err) => {
            this.status2 = false
          }
        )
    }
  }
}
